import { render } from "./AntifraudView.vue?vue&type=template&id=7c0048c8&scoped=true"
const script = {}

import "./AntifraudView.vue?vue&type=style&index=0&id=7c0048c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0048c8"]])

export default __exports__